import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { finalize, map, Observable, of, tap } from 'rxjs';
import { VendorService } from '../services/vendor-service';
import { RouterModule } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { EmployeeService } from '../services/employee-service';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
  selector: 'app-salaryadvance-requests',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    RouterModule,
    MatDialogModule,
    MatSpinner,
    MatPaginatorModule,
    MatTooltipModule
  ],
  templateUrl: './salaryadvance-requests.component.html',
  styleUrl: './salaryadvance-requests.component.css'
})
export class SalaryadvanceRequestsComponent {
  constructor(private employeeService: EmployeeService, private dialog: MatDialog) { }
  displayedColumns: string[] = [
    'slno',
    'employee_name',
    'employee_no',
    'amount',
    'request_date',
    'return_date',
    'approval_status',
    'reason'
  ];
  isLoading = false;
  advanceRequests$!: Observable<any[]>;
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.getSalaryAdvanceRequestStatus();
  }

  getSalaryAdvanceRequestStatus() {
    this.isLoading = true;
    this.advanceRequests$ = this.employeeService.getSalaryAdvanceRequestStatus().pipe(
      map((res: any) => res.result.data),
      finalize(() => this.isLoading = false)
    );
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }
}
